import { Injectable, inject } from '@angular/core';
import { IFileEntity } from '@app/pages/cmms/interfaces/files.interfaces';
import { Store } from '@ngrx/store';
import {
	addImportedFiles,
	removeImportedFiles,
	setImportedFiles,
	updateImportedFiles,
} from '../file-table/files-state/imported-files.actions';
import { TableItemListHandler } from '../interfaces/file-import.interfaces';

@Injectable({
	providedIn: 'root',
})
export class FileListControlFacade implements TableItemListHandler<IFileEntity> {
	//  Abstraction for editing the files list without loading from the backend
	private readonly store$ = inject(Store);
	constructor() {}

	set(files: IFileEntity[]) {
		this.store$.dispatch(setImportedFiles({ files }));
	}

	add(files: IFileEntity[]) {
		this.store$.dispatch(addImportedFiles({ files }));
	}

	remove(pks: string[]) {
		this.store$.dispatch(removeImportedFiles({ pks }));
	}

	update(files: Partial<IFileEntity>[]) {
		this.store$.dispatch(updateImportedFiles({ files }));
	}
}
